




















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PreselectedRanges extends Vue {
  @Prop({ required: true })
  public options!: any[];

  @Prop({ required: false })
  public selectedBeginDate!: Date;

  @Prop({ required: false })
  public selectedEndDate!: Date;

  @Prop({ default: false })
  public time!: boolean;

  public get active() {
    return this.options.find(option => {
      const [date1, date2] = [option.dateFrom, option.dateTo];
      const granularity = this.time ? "minute" : "day";
      return (
        this.$moment(date1).isSame(this.selectedBeginDate, granularity) &&
        this.$moment(date2).isSame(this.selectedEndDate, granularity)
      );
    });
  }

  public onFocusedDateChanged(option) {
    if (option.isCustom) {
      return;
    }
    this.$emit("update-selection", [option.dateFrom, option.dateTo]);
  }
}
